import { render } from "./FormCheckbox.vue?vue&type=template&id=05e2cad6&scoped=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"

import "./FormCheckbox.vue?vue&type=style&index=0&id=05e2cad6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05e2cad6"

export default script